import EventEmitter from "../../../node_modules/eventemitter3/index";
import { Stage, StagesClient, WebhookConfiguration, WebhookConfigurationsClient, WebhookConfigurationUpdateDto } from "../client/Client";
import events from "../Events/EventList";
import EventList from "../Events/EventList";
import { TableFactory, TableInterface } from "../Utilities/Table";


let strategySelect = <HTMLSelectElement>document.querySelector("#stageId");
let plantillaSelect = <HTMLSelectElement>document.querySelector("#plantillaId");
export default class WebhookTableComponent{
    /**
     *
     */

    dtConfiguration = [
        {
            targets: 0,
            data: "description"
        },
        {
            targets: 1,
            data: "maxRetry"
        },
        {
            targets: 2,
            data: "stage.name",
        },
        {
            targets: 3,
            data: "plantillaId",
            render: (id: number)=> Array.from(plantillaSelect.options).find(e=>e.value ==id.toString())?.innerText ?? "nd"

        },
        {
            targets: 4,
            data: "url"

        },
        {
            targets: 5,
            data: "creatorUser"

        },
        {
            targets: 6,
            data: "creationDate",
            render: (date: Date) => date.toISOString().split("T")[0].split("-").reverse().join("/")

        },
        {
            targets: 7,
            data: "transitionId"

        },
        {
            targets: 8,
            data: "version"

        },
        {
            targets: 9,
            data: "id",
            render: (id: number) =>
                `<button class='btn btn-primary webhook-edit' data-webhook-id="${id}"><i class='fas fa-edit'></i></button>
                  <button class='btn btn-primary webhook-delete ml-1'><i class='fas fa-trash'></i></button>
                  <a class='btn btn-primary' href="Webhook/eventos/${id}"><i class='fas fa-list'></i></a>
                  `
            
        }
    ]

    selectedWebhook:WebhookConfiguration=null;
    selectedRow: HTMLTableRowElement= null;

    table: TableInterface<WebhookConfiguration>
    constructor(private tableFactory: TableFactory<WebhookConfiguration>, private webhookClient: WebhookConfigurationsClient, private eventEmmiter: EventEmitter) {
        $(document).on("click",".webhook-delete",this.deleteWebhookHandler)
        $(document).on("click",".webhook-edit",this.editHandler)
        this.webhookClient.getAll()
        .then(e=>this.init(e));
        this.eventEmmiter.on(events.WEBHOOK_CREATED,()=> this.webhookClient.getAll().then((e)=> {this.table.Reset(e); this.table.Draw()}));
                
    }

    deleteWebhookHandler = (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");

        this.selectedWebhook = this.table.GetData(this.selectedRow);
        Alerta.SwalConfirm("Deseas eliminar esta configuración?",this.deleteWebhook,()=>{},2)
    }

    editHandler = async (evt: Event)=>{
        let target = <HTMLElement>evt.target;
        this.selectedRow = target.closest("tr");
        this.selectedWebhook = this.table.GetData(this.selectedRow);

        const { value: formValues } = await swal.fire({
            title: 'Multiple inputs',
            html:
                
              `
              <div class="from-group">
              <label>Intentos</label><input type="number" id="swal-input1" class="form-control" value="${this.selectedWebhook.maxRetry}">
              </div>
              <div class="from-group">
              <label>Descripción</label><input type="text" id="swal-input2" class="form-control" value="${this.selectedWebhook.description}">
              </div>
              <div class="from-group">
              <label>On Fail TransitionId</label><input type="text" id="transitionIdUpdate" class="form-control" value="${this.selectedWebhook.transitionId}">
              </div>
              <input type="hidden" id="swal-input3" class="swal2-input" value='${this.selectedWebhook.id}'>`,
            focusConfirm: false,
            preConfirm: () => {
              return [
                (<HTMLInputElement>document.getElementById('swal-input1')).value,
                (<HTMLInputElement>document.getElementById('swal-input2')).value,
                (<HTMLInputElement>document.getElementById('swal-input3')).value,
                  (<HTMLInputElement>document.getElementById('transitionIdUpdate')).value
              ]
            }
          })
          
          if (formValues) {
            let dto = new WebhookConfigurationUpdateDto();
            dto.maxRetry = isNaN(parseInt (formValues[0]))?0:parseInt (formValues[0]);
            dto.transitionId = isNaN(parseInt (formValues[3]))?0:parseInt (formValues[3]);
            dto.description = formValues[1];
            try{
                await this.webhookClient.put(this.selectedWebhook.id, dto);
                Notify.success("Actualizado correctamente");
                this.webhookClient.getAll().then((e)=> {this.table.Reset(e); this.table.Draw()})
            }
            catch(ex){
                Notify.handleApiError(ex);
            }

          }
    }

    deleteWebhook= async() =>{
        try{

            await this.webhookClient.delete(this.selectedWebhook.id);
            
            this.table.DeleteRow(this.selectedRow);
            this.table.Draw();
            this.selectedWebhook = null;
            Notify.success("Eliminado correctamente");

        }
        catch(ex){
            Notify.error("Error al Eliminar Configuración");
        }
    }

    init = (configurations: WebhookConfiguration[])=>{
        this.table = this.tableFactory.Init(configurations,"#webhook-table",this.dtConfiguration); 
    }    
}